import { sendEvent } from "scripts/GoogleAnalytics"
import { useCallback, useContext } from "react"
import { CarContext } from "scenes/CarScene/CarContext"
import YoutubeLazy from "components/YoutubeLazy"
import { SliderContext } from "scenes/CarScene/Header/SliderContext"

export default function VideoSlide() {
  const {
    car: { youtubeId, brand, model, version },
    page
  } = useContext(CarContext)
  const { videoRef } = useContext(SliderContext)

  const handlePlay = useCallback(() => {
    sendEvent("Video", { event_category: page, event_label: "play carrusel" })
  }, [page])

  const altText = [brand, model, version].filter(Boolean).join(" ")

  return <YoutubeLazy videoId={youtubeId} videoRef={videoRef} handlePlay={handlePlay} autoPlay alt={altText ? `Renting ${altText}` : ""} />
}
